/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'

/**
 * Confirms the onboarding by setting the appropriate field in the user settings.
 *
 * @param {Gaia.AppModule.Spec} module        app module
 * @param {Gaia.Component} component          action component
 * @param {Gaia.AppModule.EventHandler} event event
 * @returns {Promise<void>}
 */
const confirmOnboarding = async (module, component, event) => {
  const settingsAdapter = module[G.ADAPTER][G.SETTINGS]

  await settingsAdapter[G.API].setGlobal({
    key: 'onboardingWarningConfirmation',
    value: {
      confirmed: true,
      updated: new Date(Date.now()),
    },
  })
}

export default curry(confirmOnboarding)
